// extracted by mini-css-extract-plugin
export default {"zoomModal":"l4-z"};